'use client';

import { trackedEntity } from '@cineamo/pulse';
import { usePulseTracker } from '@cineamo/pulse/react';
import type React from 'react';

import { CachedContentData } from '@/hooks/useCachedContentData';

import { TrailerAndPosterCompositeImage } from '@cineamo/composables/src/TrailerAndPosterCompositeImage';

const ContentDetailImage: React.FC<{
    content: CachedContentData;
}> = ({ content }) => {
    const { track: pulseTrack } = usePulseTracker();

    return (
        <TrailerAndPosterCompositeImage
            title={content.title}
            backdropImage={content.backdropImage}
            backdropBlurDataImage={content.backdropBlurDataImage}
            posterImage={content.posterImage}
            posterBlurDataImage={content.posterBlurDataImage}
            trailerUrl={content.trailerUrl}
            showPoster={content.showPoster}
            hideTrailer={!content.trailerUrl}
            sizes="(max-width: 1024px) 100vw, 1024px"
            trackingData={{
                movieId: content.movieId ?? ''
            }}
            onTrailerPlay={() => {
                pulseTrack({
                    ...trackedEntity({ movieId: content.movieId, contentId: content.id }),
                    event_type: 'trailer_play'
                });
            }}
            onTrailerFinished={() => {
                pulseTrack({
                    ...trackedEntity({ movieId: content.movieId, contentId: content.id }),
                    event_type: 'trailer_play_finished'
                });
            }}
        />
    );
};

export default ContentDetailImage;
